export const changePassword = (payload: { password: string }) => ({
    type: "@saga/CHANGE_PASSWORD",
    payload
});

